import React from "react";
import { EditorPopup } from "../../../popup/components/EditorPopup/EditorPopup";
import { getVideoMenuState, hideVideoMenu, setVideoMenuState, showVideoMenu, } from "../../plugins/video-menu-plugin";
import { EditorVideoMenu } from "../EditorVideoMenu/EditorVideoMenu";
export const EditorVideoMenuPluginView = ({ view }) => {
    const pluginState = getVideoMenuState(view.state);
    if (!pluginState) {
        return null;
    }
    const { pos, target } = pluginState;
    const node = view.state.doc.nodeAt(pos);
    if (!node || node.type !== view.state.schema.nodes.video) {
        return null;
    }
    const attrs = node.attrs;
    const setNodeAttrs = (updatedAttrs) => {
        view.dispatch(view.state.tr.setNodeMarkup(pos, null, {
            ...attrs,
            ...updatedAttrs,
        }));
        view.focus();
    };
    const removeNode = () => {
        view.dispatch(view.state.tr.delete(pos, pos + 1));
        view.dispatch(setVideoMenuState(view.state.tr, null));
        view.focus();
    };
    return (React.createElement(EditorPopup, { view: view, referenceElement: target, placement: "top", visibleWhenEditorUnfocused: true },
        React.createElement(EditorVideoMenu, { editable: view.editable, attrs: attrs, onAlign: (alignment) => setNodeAttrs({ alignment }), onRemove: removeNode, onMouseEnter: () => showVideoMenu(view), onMouseLeave: () => hideVideoMenu(view) })));
};
